import { createGlobalStyle } from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';
import './ToastCustom.css';

const GlobalStyle = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    font-family: "Roboto";
    box-sizing: border-box;
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;

    &:focus {
      outline: 0;
    }
  }

  h1, h2, h3, h4, h5, h6, input, button, a, p, textarea {
    font-family: "Roboto";
  }

  img,
  object,
  embed,
  video,
  iframe {
    max-width:100%;
    height: auto;
  }

  a {
    text-decoration:none;
    color:inherit;

      &:hover {
        text-decoration: none;
    }
  }

  ul {
    list-style:none;
  }

  :root {
    font-size: 62.5%;
  }

  body {
    overflow: hidden;
  }

  .disabled {
    background: #eee;
  }

  input:focus, select:focus, textarea:focus {
    box-shadow: 0 0 0 3px rgba(16, 194, 197, 0.5);
  }

  input {
    font-size: 1.1rem;
  }

  input::placeholder {
    font-size: 1.1rem;
  }

  .errorMessage {
    color: red;
    font-size: 1.2rem;
    padding-left: 10px;
    margin-top: 10px;
  }

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgb(97, 0, 130);
  }

  .recharts-legend-item {
    cursor: pointer;
  }

  .recharts-legend-item-text {
    color: #6c6c6c;
  }

  .recharts-legend-item-text:hover {
    color: #5c5c5c;
  }

  .react-tooltip-absolute-container {
    z-index: 999999;
  }

`;

export default GlobalStyle;
